import React, { useState } from 'react'
import LGAForm from './LGAForm';
import LGAList from './LGAList';

const LGADetail= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <LGAForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <LGAList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default LGADetail;